import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { EnvironmentService } from '../../services/environment.service';
import { LocalizationService } from '../../services/localization.service';
import { PersistenceService } from '../../services/persistence.service';
import { Subscription } from 'rxjs';
import { PgAcceptConditionsComponent } from '../pg-accept-conditions/pg-accept-conditions.component';
import { PGUtilities } from '../../utilities/pg-utilities';

export type PgLoginHandlerMode = 'default'|'otp'|'code';

@Component({
    selector: 'app-pg-login-handler',
    templateUrl: './pg-login-handler.component.html',
    styleUrls: ['./pg-login-handler.component.scss'],
    standalone: false
})
export class PgLoginHandlerComponent implements OnInit, OnDestroy {

    @Input() customMessage:string;
    @Input() otpMode:boolean;
    @Input() codeMode:boolean;

    @Input() canDismiss:boolean;
    @Output() loginDismissed = new EventEmitter<void>();

    availableModes:Array<PgLoginHandlerMode> = ['default'];
    currentMode:PgLoginHandlerMode = 'default';

    private _subscriptionList:Array<Subscription> = [];

    constructor(private authService:AuthService, private environmentService:EnvironmentService, private modalService:NgbModal, private localizationService:LocalizationService, private persistenceService:PersistenceService) { }

    ngOnInit(): void {
        if(this.otpMode) {
            this.availableModes.push('otp')
        }

        if(this.codeMode) {
            if(this.environmentService.environment.LoginCodePath != null && this.environmentService.environment.LoginCodePath != '') {
                this.availableModes.push('code')
            }
        }

        this._subscriptionList.push(this.authService.statusChange.subscribe(() => {
            this.handleLoginStatus();  
        }))

        setTimeout(() => {
            this.handleLoginStatus();  
        }, 10)

        this._subscriptionList.push(this.localizationService.currentLanguageChange.subscribe(() => {
            this._dismissAllModals()
            
            setTimeout(() => {
                this.handleLoginStatus();
            }, 10)
        }))
    }

    private _dismissAllModals() {
        if(this._loginModalRef != null) {
            this._loginModalRef.dismiss();
        }
        
        if(this._acceptModalRef != null) {
            this._acceptModalRef.dismiss();
        }
    }

    ngOnDestroy(): void {
        for(let _subscription of this._subscriptionList) {
            _subscription.unsubscribe();
        }
        
        this._dismissAllModals();
    }

    isLoggedIn = false;

    isLoading = false;
    isResetting = false;

    @ViewChild('loginTemplate') loginTemplate: ElementRef;

    private _loginModalRef:NgbModalRef = null;
    private _acceptModalRef:NgbModalRef = null;

    handleLoginStatus() {
        this.isLoggedIn = this.authService.isLoggedIn(true)

        if(!this.isLoggedIn) {
            if(this._loginModalRef == null) {
                let _savedObj = PGUtilities.tryParseJSON(this.persistenceService.getItem('PGLoginStatus'))

                if(_savedObj != null) {
                    if(this.availableModes.indexOf(_savedObj.mode) != -1) {
                        this.currentMode = _savedObj.mode;
                    }
                }

                let _cOptions:NgbModalOptions = {
                    backdrop: 'static',
                    keyboard: !!this.canDismiss,
                    windowClass: 'PGLoginHandlerModal',
                    size: 'lg',
                    ariaLabelledBy: 'pg-login-handler-title'
                }
    
                this._loginModalRef = this.modalService.open(this.loginTemplate, _cOptions);
                this._loginModalRef.result.then(() => {
                    this._loginModalRef = null;
                }, () => {
                    this._loginModalRef = null;
                })
            }
        }
        else {
            if(this._loginModalRef != null) {
                this._loginModalRef.dismiss();
            }

            this._checkAcceptConditions()
        }
    }

    setCurrentMode(val:PgLoginHandlerMode) {
        this.currentMode = val;
        this.userRequest = null;
    }

    private _checkAcceptConditions() {
        if(this._acceptModalRef != null) {
            this._acceptModalRef.dismiss();
        }

        if(!this.authService.user.hasAcceptedPrivacyPolicy() || !this.authService.user.hasAcceptedTermsAndConditions()) {
            this._acceptModalRef = this.modalService.open(PgAcceptConditionsComponent, { size: 'lg' })

            let _component = this._acceptModalRef.componentInstance as PgAcceptConditionsComponent;
            _component.acceptTitle = '';
            _component.conditionList = [
                { title: 'pg-footer.terms-and-conditions', text: this.localizationService.getTermsAndConditionsString() },
                { title: 'pg-footer.privacy-policy', text: this.localizationService.getPrivacyPolicyString() },
            ]

            this._acceptModalRef.result.then(() => {
                this.authService.accept(_component.conditionList[0].accepted, _component.conditionList[1].accepted).then(() => {
                    
                }, () => {})
            }, () => {})
        }
    }

    resetLoginFields() {          
        this.isResetting = true;

        setTimeout(() => {
            this.isResetting = false;
        }, 10)
    }

    dismissLogin() {
        if(this.canDismiss) {
            if(this._loginModalRef != null) {
                this._loginModalRef.dismiss();
            }

            this.loginDismissed.emit()
        }
    }

    userRequest:string = null;

    onSetUserRequest(val:string) {
        this.userRequest = val;
    }
}
